const urlName = '/usercenter/v2/t-b/saas'

export default (API) => ({
	// 获取用户组织
	getFindOrganList() {
		return API({ url: `${urlName}/findMySaas`,method: 'post' })
	},
})
